import { Component, OnInit } from '@angular/core';
import { Globals } from 'src/app/shared/services/globals';
import { PermissionService } from 'src/app/account/services/permission.service'
import { data } from 'jquery';
import { Permission } from 'src/app/shared/models/BasicData/Permission';

@Component({
  selector: 'app-admin-menu',
  templateUrl: './admin-menu.component.html',
  styleUrls: ['./admin-menu.component.css']
})
export class AdminMenuComponent implements OnInit {
  permssions: Permission[];
  constructor(private g: Globals, private permService: PermissionService) { }

  ngOnInit() {

    //alert('AAA');
    //    alert(this.g.Role);
    // document.getElementById('mnItem1').hidden=true;

  }
  ngAfterViewInit() {

    // this.permService.GetCompPermssions('AdminMenuComponent').toPromise().then(res => {
    //   this.permssions = ((res as any).data) as Permission[];
    //   console.log(this.permssions);
    //   this.permssions?.forEach(element => {
    //     if (document.getElementById(element.elementId)) {
    //       document.getElementById((element as any).elementId).hidden = true;
    //     }
    //   });
    //   console.log('localstorage');
    //   console.log(this.g.getPermissions());
    //   this.g.getPermissions()?.forEach(element => {
    //     if (document.getElementById(element.elementId)) {
    //       document.getElementById(element.elementId).hidden = !element.isReadWrite

    //       document.getElementById(element.elementId).hidden = element.isHidden
    //     }
    //   });
    // }
    // )
  }
}
